import React,{useEffect,useMemo,useState} from 'react';
import api from '../../utils/api';
import { FaClipboardCheck, FaHourglassHalf, FaVial } from 'react-icons/fa';
import { DashboardChartGrid, KpiGrid, PortalHero } from '../../components_shared/PortalDashboard';

export default function QCDashboardPage(){
  const [stats,setStats]=useState(null); const [series,setSeries]=useState([]);

  useEffect(()=>{(async()=>{
    try{
      const sum=await api.get('/api/v1/inventory/reports/qc/summary');
      setStats(sum.data);
      // last 30 days
      const end=new Date();const start=new Date();start.setDate(end.getDate()-29);
      const fmt=d=>d.toISOString().slice(0,10);
      const rep=await api.get('/api/v1/inventory/reports/qc',{params:{from:fmt(start),to:fmt(end)}});
      const chartRows=[];
      for(let d=new Date(start);d<=end;d.setDate(d.getDate()+1)){
        const ds=fmt(d);chartRows.push({name:ds.slice(5),value:rep.data.find(x=>x.date===ds)?.count||0});
      }
      setSeries(chartRows);
    }catch{setStats({pending:0,completedToday:0,monthTotal:0});}
  })();},[]);

  const safeStats=stats||{pending:0,completedToday:0,monthTotal:0};
  const cards=[
    {icon:<FaHourglassHalf/>,label:'Pending',value:safeStats.pending,desc:'Awaiting QC evaluation',className:'eduss-dashboard-card-yellow'},
    {icon:<FaClipboardCheck/>,label:'Completed Today',value:safeStats.completedToday,desc:'QC receipts finalized today',className:'eduss-dashboard-card-green'},
    {icon:<FaVial/>,label:'Total This Month',value:safeStats.monthTotal,desc:'Monthly QC throughput',className:'eduss-dashboard-card-blue'}
  ];
  const charts=useMemo(()=>[
    {title:'QC Workload',caption:'Current summary',type:'bar',data:[
      {name:'Pending',value:Number(safeStats.pending||0)},
      {name:'Today',value:Number(safeStats.completedToday||0)},
      {name:'Month',value:Number(safeStats.monthTotal||0)}
    ],color:'#0f6fad'},
    {title:'QC Completion Trend',caption:'Last 30 days',type:'line',data:series.length?series:[{name:'No Data',value:0}],color:'#10ac84'}
  ],[safeStats.pending,safeStats.completedToday,safeStats.monthTotal,series]);

  if(!stats) return <div>Loading...</div>;

  return (<div className="eduss-dashboard">
      <PortalHero title="Quality Control Dashboard" subtitle="Track pending inspections, completed receipts, and QC movement." />
      <KpiGrid cards={cards}/>
      <DashboardChartGrid charts={charts}/>
    </div>);
}
